import "./App.css";
import TimelogTracker from "./components/TimelogTracker";
export default function App() {
  return <TimelogTracker />;
}
